import { useState } from "react";

const sizeMap = { sm: 28, md: 40, lg: 52 };

export default function Avatar({ user, size = 40, rounded = true, status }) {
  const [imgError, setImgError] = useState(false);
  const px = typeof size === "number" ? size : (sizeMap[size] ?? 40);
  const radius = rounded ? "50%" : "10px";

  const initials = [user?.first_name, user?.last_name]
    .filter(Boolean)
    .map((n) => n[0].toUpperCase())
    .join("") || "?";

  const bg = user?.colour_code || "#35355D";

  const dotColor =
    status === "ONLINE" ? "#4f7a5b" :
    status === "OFFLINE" ? "#8D3233" : null;

  return (
    <span style={{ position: "relative", display: "inline-flex", flexShrink: 0 }}>
      {user?.profile_picture_url && !imgError ? (
        <img
          src={user.profile_picture_url}
          alt={initials}
          onError={() => setImgError(true)}
          style={{
            width: px, height: px, borderRadius: radius,
            objectFit: "cover", display: "block",
          }}
        />
      ) : (
        <span
          style={{
            width: px, height: px, borderRadius: radius,
            background: bg, color: "#fff",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            fontSize: px * 0.36, fontWeight: 600, userSelect: "none",
          }}
        >
          {initials}
        </span>
      )}
      {dotColor && (
        <span
          style={{
            position: "absolute", bottom: 0, right: 0,
            width: px * 0.28, height: px * 0.28,
            borderRadius: "50%", background: dotColor,
            border: "2px solid var(--color-surface)",
          }}
        />
      )}
    </span>
  );
}
